export var xhtml = "http://www.w3.org/1999/xhtml";

export default {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/namespaces.js
// module id = 574
// module chunks = 3